var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"100vw"}},[_c('v-toolbar',{staticClass:"px-4 py-3",attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(" Soporte ")])],1),_c('div',[_vm._v(" "+_vm._s(_vm.columns)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }